import { useAtomValue } from 'jotai';
import {
  accStatementDemoModeAtom,
  assistDemoModeAtom,
  auditDemoModeAtom,
  demoModeAtom,
  easyDemoModeAtom,
  reportDemoModeAtom,
  translateDemoModeAtom,
} from '@/global-store';

export type BadgeShowWhen =
  | 'always'
  | 'reportDemoMode'
  | 'accStatementDemoMode'
  | 'auditDemoMode'
  | 'assistDemoMode'
  | 'translateDemoMode'
  | 'easyDemoMode';

export type NavTitleBadge = {
  text?: string;
  showWhen?: BadgeShowWhen;
};

export function useBadgeVisibility(badge?: NavTitleBadge) {
  const reportDemoMode = useAtomValue(reportDemoModeAtom);
  const accStatementDemoMode = useAtomValue(accStatementDemoModeAtom);
  const assistDemoMode = useAtomValue(assistDemoModeAtom);
  const auditDemoMode = useAtomValue(auditDemoModeAtom);
  const easyDemoMode = useAtomValue(easyDemoModeAtom);
  const translateDemoMode = useAtomValue(translateDemoModeAtom);
  const generalDemoMode = useAtomValue(demoModeAtom);

  if (!badge?.showWhen) return false;

  if (badge.showWhen === 'always') return true;
  if (generalDemoMode) return false;

  const demoModeMap: Record<Exclude<BadgeShowWhen, 'always'>, boolean> = {
    reportDemoMode,
    accStatementDemoMode,
    auditDemoMode,
    assistDemoMode,
    translateDemoMode,
    easyDemoMode,
  };

  return Boolean(demoModeMap[badge.showWhen]);
}
